import {usePage} from "@inertiajs/vue3";
import parseUserCertificates from "@/helpers/sign/parseUserCertificates.js";

export default async function (organizationInn = null) {
    return (await parseUserCertificates()).map(cert => {
        const subject = cert.subjectName
            .replaceAll('  ', ' ')
            .replaceAll(' = ', '=')
            .toLowerCase();

        console.log('parsed subject', subject);
        if (organizationInn && ~subject.indexOf('инн юл')) {
            if (!~subject.indexOf(`инн юл=${organizationInn}`)) {
                console.log('invalid INNLE in certificate');
                return {
                    ...cert,
                    invalid: true,
                    invalidMessage: 'ИННЮЛ организации в ЭЦП не соответствует текущей выбранной.',
                }
            }
        }


        const user = usePage().props.auth.user;
        if (
            ~subject.indexOf(`инн=${user.inn}`) &&
            ~subject.indexOf(`снилс=${user.snils}`)
        ) {
            return cert;
        }

        console.log('invalid INN or SNILS in certificate');

        return {
            ...cert,
            invalid: true,
            invalidMessage: 'ИНН или СНИЛС в  ЭЦП не соответствует настройкам аккаунта.',
        }
    })
        .filter(c => c.subjectName.includes('ИНН'))
        .sort((a, b) => Number(Boolean(a.invalid)) - Number(Boolean(b.invalid)));
}
